import React from "react";
import PropTypes from "prop-types";
import { TableRow } from "@mui/material";

import TableItem from "../../../ui/TableItem";
import { INTX_TYPE_TO_LABEL } from "../../../constants/intxConstants";
import { SAFETY_INPUT_TYPES } from "./safetyConstants";
import { intxTypePropType } from "../../../util/propTypeHelper";

const SAFETY_INPUT_TYPE_TO_LABEL = {
  [SAFETY_INPUT_TYPES.CMF_USER_ENTERED]:
    "User entered CMFs do not have defaults",
  [SAFETY_INPUT_TYPES.SPF]: "Uses safety performance function (SPF)",
};
export default function EmptyCmfRow({ intxType, safetyAnalysisType }) {
  return (
    <TableRow>
      <TableItem size="small">{INTX_TYPE_TO_LABEL[intxType]}</TableItem>
      <TableItem></TableItem>
      <TableItem>{SAFETY_INPUT_TYPE_TO_LABEL[safetyAnalysisType]}</TableItem>
      <TableItem></TableItem>
    </TableRow>
  );
}

EmptyCmfRow.propTypes = {
  intxType: intxTypePropType.isRequired,
  safetyAnalysisType: PropTypes.oneOf([
    SAFETY_INPUT_TYPES.CMF_USER_ENTERED,
    SAFETY_INPUT_TYPES.SPF,
  ]).isRequired,
};
